export type GameSearchCategory =
  | "item"
  | "npc"
  | "skill"
  | "map"
  | "quest"
  | "kimAn"
  | "kimToa"
  | "gameCommand"
  | "donate"
  | "serverEvent";

export type GameSearchField = {
  label: string;
  value: string;
  hint?: string;
  /** Nếu có, render value như các chip click để search tiếp */
  searchTokens?: string[];
};

export type GameSearchStat = {
  key: string;
  label: string;
  value: string;
  hint?: string;
};

export type GameSearchChip = {
  id?: string;
  primary: string;
  secondary?: string;
  imageUrl?: string;
  /** Nếu có, click chip sẽ mở trang search với query này */
  searchQuery?: string;
  quantity?: number;
  itemId?: number;
};

export type GameSearchChipGroup = {
  title: string;
  hint?: string;
  chips: GameSearchChip[];
  /** UI quà event theo tầng (pill + grid) */
  layout?: "default" | "eventRewards";
};

export type GameSearchBadge = {
  label: string;
  hint?: string;
  className?: string;
  /** Chấm màu hệ (Địa, Phong, Thủy, Hỏa, Tâm) */
  dotClass?: string;
  /** Badge nền màu (yellow, blue, purple, …) */
  tone?: "default" | "secondary" | "destructive" | "success" | "yellow" | "blue" | "purple" | "warning" | "outline";
};

export type GameSearchResult = {
  id: string;
  category: GameSearchCategory;
  title: string;
  /** Link gắn vào title (mở tab mới) */
  titleHref?: string;
  subtitle?: string;
  description?: string;
  /** PNG từ data/game/icons qua /api/game-icons/… */
  imageUrl?: string;
  badges?: GameSearchBadge[];
  stats?: GameSearchStat[];
  chipGroups?: GameSearchChipGroup[];
  fields: GameSearchField[];
  /** NPC drop sources when searching items */
  related?: { label: string; value: string; hint?: string }[];
};

export type GameSearchBucket = Record<GameSearchCategory, GameSearchResult[]>;

export type GameSearchResponse = {
  query: string;
  total: number;
  results: GameSearchBucket;
};

export const GAME_SEARCH_CATEGORY_LABELS: Record<GameSearchCategory, string> = {
  item: "Vật phẩm",
  npc: "NPC",
  skill: "Kỹ năng",
  map: "Bản đồ",
  quest: "Nhiệm vụ",
  kimAn: "Kim ấn",
  kimToa: "Kim tỏa",
  gameCommand: "Lệnh game",
  donate: "Donate",
  serverEvent: "Sự kiện server",
};
